import React from 'react';

import {StdH1, StdH2, StdH3Small, StdH3Big, StdFontText} from './styles';



const Text= ({title, family, color, typeFont, tag, size}) => {
  let fontFamilyValue; // Use undefined to handle default cases better.

  switch (family) {
    case 'text':
      fontFamilyValue = 'var(--font-family-text, vw-text, Helvetica, Arial, sans-serif)';
      break;
    case 'textLight':
      fontFamilyValue =
        'var(--font-family-text-light, vw-text-light, Helvetica, Arial, sans-serif)';
      break;
    case 'textBold':
      fontFamilyValue = 'var(--font-family-text-bold, vw-text-bold, Helvetica, Arial, sans-serif)';
      break;
    case 'head':
      fontFamilyValue = 'var(--font-family-head, vw-head, Helvetica, Arial, sans-serif)';
      break;
    case 'headLight':
      fontFamilyValue =
        'var(--font-family-head-light, vw-head-light, Helvetica, Arial, sans-serif)';
      break;
    case 'headBold':
      fontFamilyValue = 'var(--font-family-bold, vw-bold, Helvetica, Arial, sans-serif)';
      break;

    default:
      fontFamilyValue = undefined; // Explicitly set undefined for default case.  Alternatively, use a fallback value.
      break;
  }

  return (
    <>
      {typeFont === 'text' ? (
        <StdFontText $family={fontFamilyValue || ''} color={color || 'rgb(0,14,38'}>
          {title}
        </StdFontText>
      ) : (
        <>
          {tag === 'h1' ? (
            <StdH1 $family={fontFamilyValue || 'var(--font-family-text, vw-text, Helvetica, Arial, sans-serif)'} color={color} >
              {title}
            </StdH1>
          ) : tag === 'h2' ? (
            <StdH2 $family={fontFamilyValue || 'var(--font-family-head, vw-head, Helvetica, Arial, sans-serif)'} color={color}>
              {title}
            </StdH2>
          ) : tag === 'h3Small' ? (
            <StdH3Small $family={fontFamilyValue || 'var(--font-family-head, vw-head, Helvetica, Arial, sans-serif)'} color={color}>
              {title}
            </StdH3Small>
          ) : (
            <StdH3Big $family={fontFamilyValue || 'var(--font-family-head, vw-head, Helvetica, Arial, sans-serif)'} color={color}>
              {title}
            </StdH3Big>
          )}
        </>
      )}
    </>
  );
};
export default Text;
